mutation UserTemplateUserSync($input: UserTemplateUserSyncInput!) {
  userTemplateUserSync(input: $input) {
   clientMutationId
  _totalUpdatedUsers
  }
}
